import { useState } from 'react';
import {
    Box,
    Checkbox,
    ListItemText,
    MenuItem,
    Paper,
    Select,
    SelectChangeEvent,
    Stack,
} from '@mui/material';

import { GiftPlannerBoard } from '../components/GiftPlannerBoard';
import { PlanNewGiftButton } from '../components/PlanNewGiftButton';

type PlannerStatus = 'open' | 'done';

const PLANNER_STATUSES: { label: string; value: PlannerStatus }[] = [
    { label: 'In progress', value: 'open' },
    { label: 'Done', value: 'done' },
];

export const GiftPlannerPage = () => {
    const [statuses, setStatuses] = useState<PlannerStatus[]>(['open']);

    const handleChange = (event: SelectChangeEvent<PlannerStatus[]>) => {
        const { value } = event.target;
        const next =
            typeof value === 'string'
                ? (value.split(',') as PlannerStatus[])
                : value;
        if (next.length > 0) setStatuses(next);
    };

    return (
        <Stack spacing={2}>
            <Paper
                variant="outlined"
                sx={{
                    p: 1.5,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 1,
                    borderRadius: 2,
                }}
            >
                <Select
                    multiple
                    size="small"
                    value={statuses}
                    onChange={handleChange}
                    renderValue={(selected) =>
                        PLANNER_STATUSES.filter((tab) =>
                            selected.includes(tab.value),
                        )
                            .map((tab) => tab.label)
                            .join(', ')
                    }
                    sx={{ minWidth: 200 }}
                >
                    {PLANNER_STATUSES.map((tab) => (
                        <MenuItem key={tab.value} value={tab.value}>
                            <Checkbox checked={statuses.includes(tab.value)} />
                            <ListItemText primary={tab.label} />
                        </MenuItem>
                    ))}
                </Select>

                <Box>{statuses.includes('open') && <PlanNewGiftButton />}</Box>
            </Paper>

            <GiftPlannerBoard statuses={statuses} />
        </Stack>
    );
};
